export const BrowserDetect = {
  webkit: 'webkitWritingMode' in document.documentElement.style && !window['StyleMedia'],
};
